import { userTypes } from "@/store/types/store-types.js";
import api from "@/api";

const state = {
  userList: [],
  user: {},
  keyword: "",
  page: 1
};
const getters = {
  [userTypes.getters.getUserList]: state => state.userList,
  [userTypes.getters.getUserIndex]: state => state.userIndex,
  [userTypes.getters.getWeekList]: state => state.weekList,
  [userTypes.getters.getKeyword]: state => {
    return {
      q: state.keyword,
      page: state.page
    };
  }
};
const mutations = {
  [userTypes.mutations.GET_USER_LIST]: (state, userList) => {
    state.userList = userList;
  },
  [userTypes.mutations.GET_SINGLE_USER]: (state, user) => {
    state.user = user;
  },
  [userTypes.mutations.SET_USER_INDEX]: (state, index) => {
    state.userIndex = index;
  },
  [userTypes.mutations.SET_SEARCH_KEYWORD]: (state, keyword) => {
    state.keyword = keyword;
  },
  [userTypes.mutations.SET_SEARCH_PAGE]: (state, page) => {
    state.page = page;
  }
};

const actions = {
  [userTypes.actions.QUERY_USER_LIST]: ({ commit }, query) => {
    return api.getUserList(query).then(data => {
      data = data.map(user => {
        user.state = false;
        return user;
      });
      commit(userTypes.mutations.GET_USER_LIST, data);
      return data;
    });
  },
  [userTypes.actions.QUERY_SINGLE_USER]: ({ commit }, query) => {
    return api.getSingleUser(query).then(data => {
      commit(userTypes.mutations.GET_SINGLE_USER, data);
      return data;
    });
  },
  [userTypes.actions.ADD_USER]: (_, user) => {
    delete user.id;
    delete user.is_cashbag_out;
    delete user.cashbag_out_at;
    return api.addUser(user).then(async res => {
      return res;
    });
  },
  [userTypes.actions.EDIT_USER]: ({ dispatch }, user) => {
    const id = user.id;
    delete user.id;
    delete user.is_cashbag_out;
    delete user.cashbag_out_at;
    return api.editUser(user, id).then(() => {
      dispatch(userTypes.actions.QUERY_USER_LIST);
    });
  },
  [userTypes.actions.DELETE_USER]: ({ dispatch }, id) => {
    return api.deleteUser(id).then(res => {
      dispatch(userTypes.actions.QUERY_USER_LIST);
      return res;
    });
  },
  [userTypes.actions.EDIT_USER_CASH_BAG]: (_, data) => {
    let dataFormat = {
      is_cashbag_out: data.is_cashbag_out
    };
    return api.editUserCashBag(dataFormat, data.id);
  },
  [userTypes.actions.GET_USER_LIST_LENGTH]: () => {
    return api.getUserListLength();
  },
  [userTypes.actions.GET_SEARCH_KEYWORD]: ({ commit }, data) => {
    commit(userTypes.mutations.SET_SEARCH_KEYWORD, data.q);
    commit(userTypes.mutations.SET_SEARCH_PAGE, data.page);
  },
  [userTypes.actions.QUERY_USER_PHONE]: (_, query) => {
    return api.getUserList(query).then(data => data);
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
